import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import userReducer from './userSlice';
import hospitalReducer from './hospitalSlice';
import teamReducer from './teamSlice';
import invitationsReducer from './invitationsSlice';
import payersReducer from './payersSlice';
import fieldsReducer from './fieldsSlice';
import rulesReducer from './rulesSlice';
import providerReducer from './providerSlice';

const hospitalsPersistConfig = {
  key: 'hospitals',
  storage,
  whitelist: ['hospitals', 'selectedHospital'],
};

const rootReducer = combineReducers({
  user: userReducer,
  hospitals: persistReducer(hospitalsPersistConfig, hospitalReducer),
  team: teamReducer,
  invitations: invitationsReducer,
  payers: payersReducer,
  fields: fieldsReducer,
  rules: rulesReducer,
  providers: providerReducer,
});

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['hospitals'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
